module.exports = {
}


// WEBPACK FOOTER //
// ./src/pages/login/i18n/locale.en.js